import { useRef, useEffect } from "react";

const close = (ref) => {
    if (ref.click_should_be_open) delete ref.click_should_be_open;
    const infoWindow = ref.click_infowindow;
    if (!infoWindow) return;

    infoWindow.setAnchor(null);
    infoWindow.setMap(null);
};

// this function handles the case when the marker is clicked, but we have no data to open it
// it this happens, save the "click" reference, so it works as a "should be open" state
const defaultOpen = (ref) => (
    () => (ref.click_should_be_open = true)
);

// the data of the marker changed. close the open infowindow,
// but save the "should be open" state if its the case
const resetDefaults = (thisInfoWindowInfo) => {
    const currentClickInfoWindow = thisInfoWindowInfo.click_infowindow;
    thisInfoWindowInfo.open = defaultOpen(thisInfoWindowInfo);

    const clickOpen = currentClickInfoWindow?.getMap?.();
    if (clickOpen) thisInfoWindowInfo.click_should_be_open = true;
    if (clickOpen) globalThis.currentClick.setAnchor(null);
    if (clickOpen) globalThis.currentClick.setMap(null);
};

const MapMarker = ({ data, childrenCommon, getContent }) => {
    const infoWindowInfo = useRef({});
    if (!infoWindowInfo.current.open) infoWindowInfo.current.open = defaultOpen(infoWindowInfo.current);
    const latitud = data.latitud;
    const longitud = data.longitud;

    const scaledSizeX = 40;
    const scaledSizeY = 40;

    const anchorX = 20;
    const anchorY = 20;

    useEffect(() => {
        const { gmap, bounds } = childrenCommon;
        if (!gmap) return;

        //if (!Number.isFinite(latitud) && !Number.isFinite(longitud == "number")) return;
        const LatLng = new globalThis.google.maps.LatLng(latitud, longitud);

        const marker = new globalThis.google.maps.Marker({
            position: LatLng,
            draggable: false,
            map: gmap,
            icon: {
                url: `${process.env.PUBLIC_URL}/img/map-icon.png`,
                scaledSize: new globalThis.google.maps.Size(scaledSizeX, scaledSizeY),
                anchor: new globalThis.google.maps.Point(anchorX, anchorY)
            }
        });
        bounds.extend(LatLng);

        marker.addListener("click", () => {
            infoWindowInfo.current.open();
        }, { passive: true });

        const thisInfoWindowInfo = infoWindowInfo.current;
        thisInfoWindowInfo.anchor = marker;
        return () => {
            if (thisInfoWindowInfo.anchor === marker) thisInfoWindowInfo.anchor = null;
            marker.setMap(null);
        };
    }, [data, latitud, longitud, childrenCommon]);

    useEffect(() => {
        const { gmap } = childrenCommon;
        if (!gmap || !getContent) return;
        const thisInfoWindowInfo = infoWindowInfo.current;

        const latitud = data?.latitud || data?.position?.lat;
        const longitud = data?.longitud || data?.position?.lng;
        //if (!Number.isFinite(latitud) && !Number.isFinite(longitud)) return;
        const LatLng = new globalThis.window.google.maps.LatLng(latitud, longitud);

        const open = thisInfoWindowInfo.open = () => {
            const content = getContent(data);
            close(thisInfoWindowInfo);

            if (!content?.content) return;
            const anchor = thisInfoWindowInfo.anchor;
            const params = { ...content, position: LatLng };

            let infoWindow = thisInfoWindowInfo.click_infowindow;
            if (infoWindow) {
                infoWindow.setOptions(params);
            } else {
                infoWindow = thisInfoWindowInfo.click_infowindow = new globalThis.window.google.maps.InfoWindow(params);
            }
            infoWindow.open(gmap, anchor?.getMap?.() === gmap ? anchor : null);
        };

        if (thisInfoWindowInfo.click_should_be_open) open();

        return () => resetDefaults(thisInfoWindowInfo);
    }, [data, childrenCommon, getContent]);

    return null;
};

export { MapMarker };
